import script from "./pressPage.vue?vue&type=script&setup=true&lang=js"
export * from "./pressPage.vue?vue&type=script&setup=true&lang=js"

import "./pressPage.vue?vue&type=style&index=0&id=2f05e628&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f05e628"]])

export default __exports__